import { useEffect, useState } from 'react'
import {
  getDashboardSignedProjectsV2,
  type DashboardSignedProjectsPageV2Dto,
  type GetDashboardSignedProjectsV2Params,
} from '@/lib/api/v2/dashboard'

export function useDashboardSignedProjectsV2(params: GetDashboardSignedProjectsV2Params) {
  const [data, setData] = useState<DashboardSignedProjectsPageV2Dto | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const [reloadKey, setReloadKey] = useState(0)

  useEffect(() => {
    let cancelled = false
    setIsLoading(true)
    setError(null)

    getDashboardSignedProjectsV2(params)
      .then((d) => {
        if (cancelled) return
        setData(d)
      })
      .catch((e) => {
        if (cancelled) return
        setError(e)
        setData(null)
      })
      .finally(() => {
        if (cancelled) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.page, params.pageSize, params.orderBy, params.orderDir, reloadKey])

  const refetch = () => setReloadKey((k) => k + 1)

  return { data, isLoading, error, refetch }
}
